import { combineReducers } from '@reduxjs/toolkit';
import studentReducer from './studentSlice';
import documentReducer from './documentSlice';
import organizationsReducer from './organizationsSlice';
import messagesReducer from './messagesSlice';

const appReducer = combineReducers({
  students: studentReducer,
  documents: documentReducer,
  organizations: organizationsReducer,
  messages: messagesReducer,
});

const rootReducer = (state, action) => {
  if (action.type === 'RESET_STATE') {
    state = undefined;
  }
  return appReducer(state, action);
};

export default rootReducer;
